// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__n9OKb","box":"style__box__ZfDB8"};